export function asArray(value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
}
